import update from "immutability-helper";
import * as CreDtos from "../CRE.dtos";

import {
    RESEARCH_REQUEST,
    RESEARCH_REQUEST_SUCCESS,
    RESEARCH_REQUEST_FAILURE,
    RESEARCH_FILTER,
    RESEARCH_EDIT,
    RESEARCH_ADD,
    RESEARCH_CANCEL,
    RESEARCH_UPSERT_REQUEST,
    RESEARCH_UPSERT_REQUEST_SUCCESS,
    RESEARCH_UPSERT_REQUEST_FAILURE
} from "../actions/research.actions";

const initialState = {
    research: [],
    focus: [],
    states: [],
    publications: [],
    filteredResearch: [],
    researchItem: { id: -1 },
    isLoading: true,
    search: "",
    showDisabled: false,
    isSaving: false
};

function loading(state, isLoading) {
    let newState = update(state, {
        isLoading: { $set: isLoading }
    });
    return newState;
}

function saving(state, isSaving) {
    let newState = update(state, {
        isSaving: { $set: isSaving }
    });
    return newState;
}

function setResearch(state, research, focus, states, publications, people) {
    let newState = update(state, {
        research: { $set: research },
        focus: { $set: focus },
        states: { $set: states },
        publications: { $set: publications },
        people: { $set: people }
    });
    return newState;
}

function setFilter(state, search, showDisabled) {
    let newState = update(state, {
        search: { $set: search },
        showDisabled: { $set: showDisabled }
    });
    return newState;
}

function setFilteredResearch(state) {
    let research = [...state.research];
    if (!state.showDisabled) {
        research = research.filter(f => f.enabled);
    }
    if (state.search !== "") {
        research = research.filter(f => {
            if (f.title) {
                if (f.title.toLowerCase().indexOf(state.search.toLowerCase()) != -1) {
                    return true;
                }
            }
            return false;
        });
    }
    let newState = update(state, {
        filteredResearch: { $set: research }
    });
    return newState;
}

function setResearchItem(state, researchItem) {
    if (researchItem.id != -1) {
        if (researchItem.id == 0) {
            researchItem = new CreDtos.Research();
            researchItem.id = 0;
            researchItem.enabled = true;
        }
    }
    let newState = update(state, {
        researchItem: { $set: researchItem }
    });
    return newState;
}

export default function research(state = initialState, action) {
    switch (action.type) {
        case RESEARCH_REQUEST:
            return loading(state, true);
        case RESEARCH_REQUEST_SUCCESS:
            return setFilteredResearch(setResearch(loading(state, false), action.research, action.focus, action.states, action.publications, action.people));
        case RESEARCH_REQUEST_FAILURE:
            return loading(state, false);
        case RESEARCH_FILTER:
            return setFilteredResearch(setFilter(state, action.search, action.showDisabled));
        case RESEARCH_EDIT:
            return setResearchItem(state, action.research);
        case RESEARCH_ADD:
            return setResearchItem(state, { id: 0 });
        case RESEARCH_CANCEL:
            return setResearchItem(state, { id: -1 });
        case RESEARCH_UPSERT_REQUEST:
            return saving(state, true);
        case RESEARCH_UPSERT_REQUEST_SUCCESS:
            return saving(setResearchItem(state, { id: -1 }), false);
        case RESEARCH_UPSERT_REQUEST_FAILURE:
            return saving(state, false);
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/research.ts